<template>
  <div>
    <div>
      <v-toolbar flat color="white" class="mb-4">
        <v-toolbar-title>{{ $t("routes.posts") }}</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn color="primary" :to="{ name: 'create-post' }">
          {{ $t("button.create") }}
        </v-btn>
      </v-toolbar>
      <!-- <global-search-filter :queries="queries" ref="search_filter_ref" />
      <v-row no-gutters>
        <v-col cols="12" sm="5">
          <v-select
            :items="tags"
            v-model="tagsValus"
            :label="$t('fields_names.fitler_by_tags')"
            multiple
            chips
            @change="buildTagsFilter"
            outlined
          ></v-select>
        </v-col>
        <v-col sm="4" class="text-center">
          <v-btn large @click="ClearAllFilters" class="error mt-3">{{
            $t("button.reset")
          }}</v-btn>
        </v-col>
      </v-row> -->
      <wrapping-table
        pathName="posts"
        resName="posts"
        :headersName="headers"
        ref="table_ref"
      >
        <template slot-scope="{ item, index }">
          <td class="text-sm-center">
            <v-avatar size="40">
              <v-img
                :src="
                  item.main_media
                    ? item.main_media.path
                    : require('@/assets/imgs/user.png')
                "
                alt="main_photo"
                class="hover-pointer"
                @click="showImagePreview(item.main_media)"
                :title="
                  item.main_media ? $t('labels.preview') : $t('labels.no_photo')
                "
              ></v-img>
            </v-avatar>
          </td>
          <td class="text-sm-center">{{ item.title | truncate(40) }}</td>
          <td class="text-sm-center">
            {{ item.description.replace(/<\/?[^>]+(>|$)/g, "") | truncate(40) }}
          </td>
          <td class="text-sm-center">
            {{ $moment(item.date).format("YYYY-MM-DD") }}
          </td>

          <td class="toggle-spacing text-center">
            <toggle-service
              :is-edit="true"
              model-name="posts"
              :model-id="item.id"
              field="premium"
              v-model="item.premium"
              :validate="true"
            />
          </td>
          <td class="text-sm-center">
            <v-btn icon :to="`/posts/edit/${item.slug}`">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-icon small @click="handleDelete(item, index)">mdi-delete</v-icon>
          </td>
        </template>
      </wrapping-table>

      <!-- Image Preview -->
      <global-image-preview
        :showDialog="imageOverlay"
        :imagePath="currentPreviewImage"
        @closePreview="imageOverlay = false"
      />
      <!-- Image Preview -->
    </div>
  </div>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";
export default {
  name: "Posts",

  data() {
    return {
      news: [],
      headers: ["photo", "title", "desc", "date", "premium", "actions"],
      pagination: {},
      loader: true,
      filterQuery: {},
      imageOverlay: false,
      currentPreviewImage: "",
      queries: {
        query: {
          title: "",
          publisher: ""
        }
      },
      tags: [],
      tagsValus: []
    };
  },

  created() {
    // window.navigator.geolocation.getCurrentPosition(
    //   position => console.log(position, "position"),
    //   err => console.log(err)
    // );
  },
  methods: {
    buildTagsFilter() {
      let queries = {};
      queries.tags = this.tagsValus.join();
      if (queries["tags"] === "") {
        this.$router.push({ query: {} });
      } else {
        const query = { ...this.$route.query, ...queries };
        this.$router.push({ query });
      }
    },
    async getTags() {
      const res = await IndexData({ reqName: "tags" });
      const { data } = res.data;

      this.tags = data.map(el => el.name);
    },
    ClearAllFilters() {
      this.$refs.search_filter_ref.ClearFilter();
      // this.$refs.toggle_filter_ref.ClearFilter();
      this.topic = "";
      this.$router.push({ query: {} });
    },
    createNews() {
      this.$router.push("/news/new");
    },
    handleEdit({ slug }) {
      this.$router.push({ path: "/posts/new", query: { slug } });
    },
    handleDelete({ slug }, index) {
      this.$refs.table_ref.handleDelete(slug, index);
    },
    showImagePreview(image) {
      if (image) {
        this.currentPreviewImage = image.path;
        this.imageOverlay = true;
      }
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        // this.getTags();
        this.tagsValus = query.tags ? query.tags.split(",") : "";
      },
      immediate: true
    }
  }
};
</script>
